import { Controller } from "@hotwired/stimulus"
import DeviceCarousel from "../carousel"

export default class extends Controller {
  connect(){
    new DeviceCarousel();
  }
}
